import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import JsonViewer from "../../../components/reusable/JsonViewer/JsonViewer";
import TableList from "../../../components/TableList/TableList";
import { selectDetalleDeAlumno, setDetalleAlumnoEmpty } from "../../../features/Dashboard/Slices/alumnosSlice";
import SlDialog from "@shoelace-style/shoelace/dist/react/dialog";
import { useAppDispatch } from "../../../app/store";
import { SlInput } from "@shoelace-style/shoelace";

function DetalleAlumno() {
  const dispatch = useAppDispatch();
  const detalleAlumno = useSelector(selectDetalleDeAlumno);
  const [filteredOferta, setFilteredOferta] = useState<any[]>([])
  const [isOpen, setIsOpen] = useState(false)
  const [searchTerm, setSearchTerm] = useState<string>("")
  const [reservasEnTransito, setReservasEnTransito] = useState<any[] | null>(
    null
  );
  const [desinscripcionesEnTransito, setDesinscripcionesEnTransito] = useState<
    any[] | null
  >(null);

  useEffect(() => {
    if (detalleAlumno) {
      if (detalleAlumno?.inscripcionesEnTransito) {
        setReservasEnTransito(detalleAlumno.inscripcionesEnTransito);
      }
      if (detalleAlumno?.desinscripcionesEnTransito) {
        setDesinscripcionesEnTransito(detalleAlumno.desinscripcionesEnTransito);
      }
      if (detalleAlumno?.kv.oferta) {
        setFilteredOferta(toSections(detalleAlumno?.kv.oferta))
      }
    }
  }, [detalleAlumno]);

  useEffect(() => {
    return () => {
      dispatch(setDetalleAlumnoEmpty());
    }
  }, [])


  if (!detalleAlumno) {
    return null
  }

  const toSections = (oferta: any) => {
    return oferta.flatMap((o: any) => o.sections).filter((s: any) => s.visibleEnOferta)
  }

  const filterOferta = (term: string) => {
    if (!detalleAlumno?.kv.oferta) return;

    const originalSections = toSections(detalleAlumno.kv.oferta);

    if (!term.trim()) {
      setFilteredOferta(originalSections);
      return;
    }

    const filtered = originalSections.filter((item: any) => {
      const searchLower = term.toLowerCase();
      const matchId = item.id?.toString().toLowerCase().includes(searchLower);
      const matchIdMateria = item.idMateria?.toString().toLowerCase().includes(searchLower);
      const matchSection = item.section?.toLowerCase().includes(searchLower);
      return matchId || matchIdMateria || matchSection;
    });

    setFilteredOferta(filtered);
  };

  const handleSearchChange = (e: any) => {
    const value = e.target.value;
    setSearchTerm(value);
    filterOferta(value);
  };

  return (
    <SlDialog
      label={`Detalle`}
      // : ${detalleAlumno.alumno.nombre} [${detalleAlumno.alumno.nombre_carrera}]
      open={detalleAlumno}
      // @ts-ignore
      style={{ "--width": "75vw" }}
      onSlAfterHide={() => {
        setIsOpen(false)
        dispatch(setDetalleAlumnoEmpty())
        setSearchTerm("")
        setFilteredOferta([])
      }}
    >
      {detalleAlumno.alumno &&
        <p className="text-center">{detalleAlumno.alumno.nombre}</p>}
      {reservasEnTransito && (
        <div>
          <div className="flex flex-row items-center pb-3">
            <b className="text-left w-2/12">Reservas en transito</b>
          </div>
          <TableList list={reservasEnTransito} page="alumnos" />
          {reservasEnTransito?.length < 1 && (
            <p>No se encontraron reservas en transito</p>
          )}
        </div>
      )}
      {desinscripcionesEnTransito && (
        <div>
          <div className="flex flex-row items-center pt-3 pb-3">
            <b className="text-left w-2/12">Desinscripciones en transito</b>
          </div>
          <TableList list={desinscripcionesEnTransito} page="alumnos" />
          {desinscripcionesEnTransito?.length < 1 && (
            <p>No se encontraron desinscripciones en transito</p>
          )}
        </div>
      )}
      {/* <div className="flex flex-row justify-center mt-2">
          <Input
            className="w-10/12"
            placeholder="Ingrese el IdAlumnoProgramar(Número)"
            type="number"
            onChange={(text) => setIdAlumnoPrograma(Number(text))}
          />
          <Button
            className="ml-3 w-2/12"
            onClick={ObtenerDetalleAlumno}
            label="Buscar"
          />
        </div> */}
      <div className="pt-5 w-12/12">
        <b>Oferta</b>
        <input
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder="Buscar por ID, ID Materia o Sección..."
          value={searchTerm}
          onChange={handleSearchChange}
          type="text"
        />
        <JsonViewer json={filteredOferta} />
      </div>
      <div className="pt-5 w-12/12"> 
        <b className="text-center">Detalle del alumno</b>
        <JsonViewer json={detalleAlumno} />
      </div>
    </SlDialog>
  );
}

export default DetalleAlumno;
